import { render } from "./transmission.vue?vue&type=template&id=46cd8972"
import script from "./transmission.vue?vue&type=script&lang=js"
export * from "./transmission.vue?vue&type=script&lang=js"

import "./transmission.vue?vue&type=style&index=0&id=46cd8972&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__